// Formateadores portados TAL CUAL desde app/app.js (líneas 144-152).
// Cualquier diferencia aquí aparece como una cifra distinta en el comparador
// vieja-vs-nueva, así que no "mejorar" el formato sin querer.

export const fmtN = (n: number | null | undefined): string =>
  (n ?? 0).toLocaleString("es-MX");

export const fmtMx = (n: number | null | undefined): string =>
  (n ?? 0).toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
    maximumFractionDigits: 0,
  });

export const fmtMin = (m: number | null | undefined): string => {
  if (m == null) return "—";
  if (m < 60) return Math.round(m) + " min";
  if (m < 1440) return (m / 60).toFixed(1).replace(/\.0$/, "") + " h";
  return (m / 1440).toFixed(1).replace(/\.0$/, "") + " días";
};

// ---------- fechas ----------

export function isoLocalDate(d: Date): string {
  return (
    d.getFullYear() +
    "-" +
    String(d.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(d.getDate()).padStart(2, "0")
  );
}

// fecha en hora LOCAL (no UTC), para que "Hoy" sea el hoy de México
export const isoLocal = (d: Date): string =>
  new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);

export interface Rango {
  desde: string;
  hasta: string;
}

// mismo número de días, inmediatamente antes de "desde" — para comparar de
// verdad, no inventar cifras
export function periodoAnterior(desde: string, hasta: string): Rango {
  const d1 = new Date(desde + "T00:00:00");
  const d2 = new Date(hasta + "T00:00:00");
  const dias = Math.round((d2.getTime() - d1.getTime()) / 864e5) + 1;
  const prevHasta = new Date(d1);
  prevHasta.setDate(prevHasta.getDate() - 1);
  const prevDesde = new Date(prevHasta);
  prevDesde.setDate(prevDesde.getDate() - (dias - 1));
  return { desde: isoLocalDate(prevDesde), hasta: isoLocalDate(prevHasta) };
}

export interface Delta {
  pct: number;
  mejor: boolean;
}

// % de cambio real entre dos valores; null si no se puede calcular (evita
// inventar datos)
export function calcDelta(
  actual: number | null | undefined,
  previo: number | null | undefined,
  favoreceBaja = false,
): Delta | null {
  if (actual == null || previo == null || !previo) return null;
  const pct = ((actual - previo) / previo) * 100;
  const subio = pct >= 0;
  const mejor = favoreceBaja ? !subio : subio;
  return { pct, mejor };
}

// primer día con datos sincronizados de verdad (arranque del backfill).
// Antes de esta fecha casi no hay oportunidades cargadas: comparar "vs. período
// anterior" contra un rango que toque antes de aquí da porcentajes absurdos.
export const DATOS_DESDE = "2026-06-20";

// Enlace directo a la ficha del lead en GoHighLevel
export const GHL_CONTACT =
  "https://app.gohighlevel.com/v2/location/M053zK3Eiz4VuTysy6oc/contacts/detail/";
